import clsx from 'clsx';
import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { ButtonProps } from './Button';
import styles from './Button.module.css';

interface RouterLinkProps extends LinkProps, Pick<ButtonProps, 'variant'> {}

export const RouterLink: FC<RouterLinkProps> = ({
  className,
  variant,
  ...rest
}) => {
  return (
    <Link
      className={clsx(
        styles.btn,
        {
          [styles.outlined]: variant === 'outlined',
          [styles.text]: variant === 'text',
        },
        className
      )}
      {...rest}
    />
  );
};
